var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector42(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H3.75C1.68225 0 0 1.68225 0 3.75V11.25C0 13.3177 1.68225 15 3.75 15H11.25C13.3177 15 15 13.3177 15 11.25V3.75C15 1.68225 13.3177 0 11.25 0ZM10.5 8.25H8.25V10.5C8.25 10.914 7.914 11.25 7.5 11.25C7.086 11.25 6.75 10.914 6.75 10.5V8.25H4.5C4.086 8.25 3.75 7.914 3.75 7.5C3.75 7.086 4.086 6.75 4.5 6.75H6.75V4.5C6.75 4.086 7.086 3.75 7.5 3.75C7.914 3.75 8.25 4.086 8.25 4.5V6.75H10.5C10.914 6.75 11.25 7.086 11.25 7.5C11.25 7.914 10.914 8.25 10.5 8.25ZM14.25 18H5.25C4.836 18 4.5 17.664 4.5 17.25C4.5 16.836 4.836 16.5 5.25 16.5H14.25C15.4905 16.5 16.5 15.4905 16.5 14.25V5.25C16.5 4.836 16.836 4.5 17.25 4.5C17.664 4.5 18 4.836 18 5.25V14.25C18 16.3177 16.3177 18 14.25 18Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector42);
export default __webpack_public_path__ + "static/media/Vector (42).273f9fbe79a6e4cf08de418eb83cc680.svg";
export { ForwardRef as ReactComponent };